import React from 'react'

import i18n from 'Pods/Shared/I18n'

function getContentRestrictionFilters(isCurrentUser, locale) {
  const wishListOnlyLabel = i18n.t('listingPage.filters.wishListOnly', { ns: 'rails', lng: locale })
  const hideOwnedModelsLabel = i18n.t('listingPage.filters.hideOwnedModels', { ns: 'rails', lng: locale })
  const ownedModelsLabel = i18n.t('listingPage.filters.ownedModels', { ns: 'rails', lng: locale })

  return [
    // Commented out the following filters are not working and returning json file in log in
    {
      value: 'wish_list_only',
      label: wishListOnlyLabel,
      count: !isCurrentUser ? (
        <a className="cgt-legacy-link content-restriction__link js-auth-control">
          Log in
        </a>
      ) : undefined,
      isDisabled: !isCurrentUser,
    },
    {
      value: 'hide_owned_models',
      label: hideOwnedModelsLabel,
      count: !isCurrentUser ? (
        <a className="cgt-legacy-link content-restriction__link js-auth-control">
          Log in
        </a>
      ) : undefined,
      isDisabled: !isCurrentUser,
    },
    ...(isCurrentUser ? [{
      value: 'owned_models',
      label: ownedModelsLabel,
      isDisabled: false,
    }] : []),
  ]
}

export default getContentRestrictionFilters
